import React from "react";
import { BadgeCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * The verified tick, and the only place it is drawn.
 *
 * It was an inline `<BadgeCheck>` in five files — the investor page, the investor
 * list, the leaderboard, a post byline and the admin table — at three different sizes
 * and with no explanation anywhere. A badge that claims something about a person
 * should say what it claims, or it is just decoration that looks like a guarantee.
 *
 * `title` gives the hover text on every platform including touch (long-press), which
 * is why it is used rather than a bespoke tooltip: this needs to work on the phone
 * the product is built for, and a custom popover on a 14px icon would not.
 *
 * The wording lives in i18n under `verified.*` so the claim is stated once and
 * translated, rather than re-invented per surface.
 */
export default function VerifiedBadge({ size = 15, className = "", testid }) {
  const { t } = useTranslation();
  return (
    <span
      role="img"
      aria-label={t("verified.label")}
      title={`${t("verified.label")} — ${t("verified.explain")}`}
      data-testid={testid || "verified-badge"}
      className={`inline-flex shrink-0 align-middle cursor-help ${className}`}
    >
      <BadgeCheck size={size} className="text-brand-500" />
    </span>
  );
}
